import type { FC, ReactNode } from 'react'

import { Fragment, useMemo } from 'react'
import { buildHighlighter } from '@/lib/search'

interface HighlightProps {
    text: string
    query?: string
}

export const Highlight: FC<HighlightProps> = ({ text, query = '' }): ReactNode => {
    const pattern = useMemo(() => buildHighlighter(query), [query])

    if (!pattern) return text

    const parts = text.split(pattern)

    return (
        <>
            {parts.map((part, index) => index % 2 === 1
                ? <mark key={index}>{part}</mark>
                : <Fragment key={index}>{part}</Fragment>
            )}
        </>
    )
}
